
import { combineReducers } from 'redux';

import totes from './totes';
import codiSeleccionada from './codiSeleccionada';

export default combineReducers({
    totes,
    codiSeleccionada
});



// WEBPACK FOOTER //
// ./src/reducers/observacio/estacio/index.js